import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../theme';

const MainLayoutDiv = styled.div`
  width: 100%;
`;

export default ({ children, bg }) => (
  <MainLayoutDiv bg={bg}>
    <ThemeProvider theme={theme}>
      <div>
        { children }
      </div>
    </ThemeProvider>
  </MainLayoutDiv>
);
